import { render, staticRenderFns } from "./AuditLogNew.vue?vue&type=template&id=51913215&scoped=true&"
import script from "./AuditLogNew.vue?vue&type=script&lang=js&"
export * from "./AuditLogNew.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogNew.vue?vue&type=style&index=0&id=51913215&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51913215",
  null
  
)

export default component.exports